import React from "react";

/**
 * Social Spectrum logo — Brand Guidelines v1.0
 *
 * Approved colourways only:
 *   primary — blue logo on white / Cloud Mist
 *   white   — white logo on Spectrum Blue / Sky Blue
 *
 * Clear space = x (icon height) on every side.
 * Minimum width: 90px digital.
 * Never stretch, squash, rotate, or place on busy backgrounds.
 *
 * Use `compact` in the sticky nav (keeps bar height practical; still
 * reserves horizontal clear space before neighbouring items).
 * Use default (full) clear space in footer / marketing locks.
 *
 * NEEDS CLIENT: official white wordmark SVG.
 */
const LOGO_SRC = {
  primary: "/images/sslogo.svg",
  white: "/images/sslogo.svg",
  mark: "/images/favicon.svg",
};

const Logo = ({
  variant = "primary",
  markOnly = false,
  compact = false,
  className = "",
  alt = "Social Spectrum",
  height = 40,
}) => {
  const src = markOnly
    ? LOGO_SRC.mark
    : variant === "white"
      ? LOGO_SRC.white
      : LOGO_SRC.primary;

  // x = icon height ≈ displayed logo height for the mark
  const x = height;

  return (
    <span
      className={`inline-flex items-center justify-center box-content ${className}`}
      style={
        compact
          ? { marginRight: Math.min(x, 16), paddingBlock: 0 }
          : { padding: x, minWidth: markOnly ? undefined : 90 + x * 2 }
      }
      data-clear-space={x}
    >
      <img
        src={process.env.PUBLIC_URL + src}
        alt={alt}
        height={height}
        className="block"
        style={{
          height,
          width: "auto",
          minWidth: markOnly ? undefined : 90,
          maxWidth: "100%",
          objectFit: "contain",
          filter: variant === "white" ? "brightness(0) invert(1)" : undefined,
        }}
        draggable={false}
      />
    </span>
  );
};

export default Logo;
